import { ExtractPropTypes } from 'vue';

export const boxProps = {};

export type BoxProps = ExtractPropTypes<typeof boxProps>;
